import * as React from 'react'
import { Account } from 'auth/state'
import PartnerCard from './partnerCard'
import { useSelector } from 'react-redux'
import { State } from 'store'
import { useHistory } from 'react-router-dom'
import './resellerDashboard.scss'

interface ResellerDashboardProps {
    accounts: Account[]
}

export const ResellerDashboard = ({ accounts }: ResellerDashboardProps) => {
    const activeAccount = useSelector((state: State) => state.preferences.activeAccount)
    const history = useHistory()

    const handleAccountClick = (accountSlug: string) => {
        if (accountSlug !== activeAccount) {
            history.push(`/account/${accountSlug}/dashboard/overview/`)
        }
    }

    return (
        <div className="reseller-dashboard">
            <h1 className="reseller-dashboard__title">Reseller dashboard</h1>
            <p>Ensure you have selected the right partner before continuing.</p>
            <div className="reseller-dashboard__grid">
                {accounts.map((account) => (
                    <PartnerCard
                        key={account.slug}
                        account={account}
                        isSelected={account.slug === activeAccount}
                        onClick={handleAccountClick}
                    />
                ))}
            </div>
        </div>
    )
}
